import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import AddNewuserLayer from "../../../components/crm/AddNewuserLayer";

const AddNewUser = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AddNewuserLayer />
      </MasterLayout>
    </>
  );
};

export default AddNewUser;